(function () {
  const SECTION_SELECTOR = '.featured-products-tabs';
  const SWIPER_SELECTOR  = '.js-fpt-swiper';

  const buildSwiperOptions = () => ({
    speed: 500,
    /* Mobile (Figma 17117:30658): 24px inset either side and an 8px gutter, so a
       428px screen shows two 186px cards plus a sliver of the third. From 750px
       up the strip goes full-bleed with the 4px gutter the rest of the home uses. */
    slidesPerView: 'auto',
    spaceBetween: 8,
    slidesOffsetBefore: 24,
    slidesOffsetAfter: 24,
    grabCursor: true,
    /* `sticky` es obligatorio: con freeMode suelto el strip frena en cualquier
       posicion y quedan cards partidas en los dos bordes. De la card cortada lo
       unico que asoma suele ser medio boton de wishlist (va pegado al borde
       derecho de su card), que es como se veia el bug. Con sticky el gesto sigue
       siendo libre pero siempre aterriza sobre un slide entero. */
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.6,
      sticky: true,
    },
    breakpoints: {
      750:  { slidesPerView: 3,   spaceBetween: 4, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
      990:  { slidesPerView: 4,   spaceBetween: 4, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
      1200: { slidesPerView: 4,   spaceBetween: 4, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
    },
  });

  const initSection = (section) => {
    if (section.dataset.fptInit === '1') return;
    if (typeof window.Swiper === 'undefined') return;
    section.dataset.fptInit = '1';

    const swipers = new Map();

    section.querySelectorAll('.featured-products-tabs__panel').forEach((panel) => {
      const swiperEl = panel.querySelector(SWIPER_SELECTOR);
      if (!swiperEl) return;
      const instance = new Swiper(swiperEl, buildSwiperOptions());
      swipers.set(panel.dataset.tabIndex, instance);
    });

    const tabs   = section.querySelectorAll('.featured-products-tabs__tab');
    const panels = section.querySelectorAll('.featured-products-tabs__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        const arr = Array.from(tabs);
        const idx = arr.indexOf(tab);
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          activateTab(arr[(idx + 1) % arr.length]).focus();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          activateTab(arr[(idx - 1 + arr.length) % arr.length]).focus();
        }
      });
    });

    function activateTab(target) {
      const id = target.dataset.tabIndex;
      tabs.forEach((t) => {
        const active = t === target;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach((p) => {
        const active = p.dataset.tabIndex === id;
        p.classList.toggle('is-active', active);
        if (active) {
          p.removeAttribute('aria-hidden');
        } else {
          p.setAttribute('aria-hidden', 'true');
        }
      });
      // Refresh the newly-visible Swiper so the peek measures against the
      // now-visible panel, and rewind to the first slide.
      const swiper = swipers.get(id);
      if (swiper) {
        requestAnimationFrame(() => {
          swiper.update();
          swiper.slideTo(0, 300);
        });
      }
      return target;
    }
  };

  const initAll = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  const bootstrap = () => initAll(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SECTION_SELECTOR).forEach((s) => {
      delete s.dataset.fptInit;
    });
  });
})();
